import {
  CANCEL,
  DONE,
  FETCH_MAP_GEOMETRY_FULFILLED,
  FETCH_MAP_GEOMETRY_PENDING,
  FETCH_MAP_GEOMETRY_REJECTED,
  FETCH_MAP_GEOMETRY_ABORT,
  SET_MAP_DATA_SOURCE,
  SET_FALLBACK_MAP_IMAGE,
} from '../constants';

export const defaultState = {
  fetched: false,
  fetching: false,
  geometryData: {},
  datasource: {},
  image: '',
};

export default function mapGeometryReduce(state = defaultState, action) {
  switch (action.type) {
    case DONE:
    case CANCEL:
      return {
        ...defaultState,
      };

    case FETCH_MAP_GEOMETRY_PENDING:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_MAP_GEOMETRY_FULFILLED: {
      return {
        ...state,
        geometryData: action.payload.body,
        fetched: true,
        fetching: false,
      };
    }

    case FETCH_MAP_GEOMETRY_REJECTED:
    case FETCH_MAP_GEOMETRY_ABORT:
      return {
        ...state,
        error: action.payload,
        fetched: true,
        fetching: false,
      };

    case SET_MAP_DATA_SOURCE:
      return {
        ...state,
        datasource: action.payload.datasource,
      };

    case SET_FALLBACK_MAP_IMAGE:
      return {
        ...state,
        image: action.payload.image,
      };

    default:
      return state;
  }
}
